/* import __COLOCATED_TEMPLATE__ from './event-part-tag-component.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/require-computed-property-dependencies */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { tagFilterUrl } from 'embercom/vendor/intercom/tag-filter-url';
import Component from '@ember/component';

export default Component.extend({
  tagName: '',
  store: service(),

  tag: computed('token', function () {
    return this.store.peekRecord('tag', this.token.id);
  }),

  tagURL: computed('tag', function () {
    return tagFilterUrl(this.tag, 'conversation');
  }),
});
